import { HttpClient } from '@angular/common/http';
import { EnvService } from '../env.service';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../env.service";
import * as i3 from "../auth.service";
import * as i4 from "@ionic-native/native-storage/ngx/index";
export class ReservationService {
    constructor(http, envService, authService, storage) {
        this.http = http;
        this.envService = envService;
        this.authService = authService;
        this.storage = storage;
        this.apiUrl = '';
        this.apiUrl = envService.API_URL;
    }
    getAvailable(params) {
        // return of(reservationsData['default']);
        return this.http.get(this.apiUrl + 'reservations/available', { withCredentials: true });
    }
    reserve(session_id, cancel_reservation_id) {
        return this.http.post(this.apiUrl + 'reservation/' + cancel_reservation_id, {
            session_id
        }, { withCredentials: true });
    }
}
ReservationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReservationService_Factory() { return new ReservationService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvService), i0.ɵɵinject(i3.AuthService), i0.ɵɵinject(i4.NativeStorage)); }, token: ReservationService, providedIn: "root" });
